import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const GallerySlider = ({hospital_images_array}) => {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const openLightbox = (index) => setLightboxIndex(index);
  const closeLightbox = () => setLightboxIndex(null);
  const prevImage = () =>
    setLightboxIndex((prev) => (prev === 0 ? hospital_images_array.length - 1 : prev - 1));
  const nextImage = () =>
    setLightboxIndex((prev) => (prev === hospital_images_array.length - 1 ? 0 : prev + 1));

  const settings = {
    dots: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0px",
    arrows: false,
  };

  return (
    <div className="gallery-slider-container">
      <Slider {...settings}>
        {hospital_images_array.map((img, idx) => (
          img.hospitalImage && (
            <div key={idx} className="slider-item">
{            console.log("🚀 ~ GallerySlider ~ img.hospitalImage:", img.hospitalImage)
}            <img src={img.hospitalImagePath} alt={`Slide ${idx}`} onClick={() => openLightbox(idx)} />
          </div>
          )
        ))}
      </Slider>
      {lightboxIndex !== null && (
        <div className="lightbox" onClick={closeLightbox}>
          <span className="close" onClick={closeLightbox}>&times;</span>
          <span className="prev" onClick={(e) => { e.stopPropagation(); prevImage(); }}>&#10094;</span>
          <img src={hospital_images_array[lightboxIndex].hospitalImagePath} alt="Popup" className="lightbox-img" />
          <span className="next" onClick={(e) => { e.stopPropagation(); nextImage(); }}>&#10095;</span>
        </div>
      )}
    </div>
  );
};

export default GallerySlider;
